import { render, staticRenderFns } from "./AlterarDadosAtendente.vue?vue&type=template&id=415bc956"
import script from "./AlterarDadosAtendente.vue?vue&type=script&lang=js"
export * from "./AlterarDadosAtendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports